import * as React from 'react'

export const HEBREW_TEXTS = {
    payment_done: 'התשלום בוצע  בהצלחה ✅ ',
    close_window: 'ניתן לסגור את החלון',
    error_main: '❌ התשלום נכשל'
}

type PaymentListenerContentProps = {
    status: string | boolean | null | undefined
}

export function PaymentListenerContent({ status }: PaymentListenerContentProps) {
    const normalizedStatus = String(status || '').toLowerCase()
    const isSuccess =
        status === true || normalizedStatus === '1' || normalizedStatus === 'true' || normalizedStatus === 'success'

    return (
        <div
            style={{
                minHeight: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontFamily: 'Arial, sans-serif',
                background: 'transparent',
                color: '#000000'
            }}
        >
            <div style={{ textAlign: 'center', padding: '24px' }}>
                <h1 style={{ fontSize: '2rem', margin: 0 }}>
                    {isSuccess ? HEBREW_TEXTS.payment_done : HEBREW_TEXTS.error_main}
                </h1>
                {isSuccess && <p style={{ fontSize: '1.5rem', margin: 0 }}>{HEBREW_TEXTS.close_window}</p>}
            </div>
        </div>
    )
}

class PaymentListener extends React.Component<any> {
    componentDidMount() {
        const status = this.props.match && this.props.match.params ? this.props.match.params.status : null
    }

    render() {
        const status = this.props.match && this.props.match.params ? this.props.match.params.status : null
        return <PaymentListenerContent status={status} />
    }
}

export default PaymentListener
